// @core/api/endpoints/analytics/create_dashboard.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateDashboardRequest,
  DashboardResponse,
} from '../../../types/analytics';

const BASE_PATH = '/analytics';

/**
 * Create a new dashboard
 * Creates a new analytics dashboard. Dashboards can be private, shared with team, tenant, or platform-wide.
 */
export async function CreateDashboard(
  data: CreateDashboardRequest,
  options?: RequestOptions
): Promise<DashboardResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/analytics/dashboards`;
  const requestOptions = options;
  return client.post<DashboardResponse>(requestPath, data, requestOptions);
}
